import phoneConfigService from "../api/server/phoneConfigService";
import errorHelper from "@/components/helpers/errorhelper";
export const PHONE_CONFIG_NAMESPACE = "phoneConfigModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/phoneConfigService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(phoneConfigService)
};

const state = {
  data: null,
  parsedData: null,
  userEvents: [],
  fileFetching: false
};
const mutations = {
  SET_USER_EVENT_LIST(storeState, data) {
    storeState.userEvents = data;
  }
};
const actions = {
  async loadUserEvents(context, data) {
    context.state.loading = true;
    var api = await services.api;
    return api.loadEvents(data).then(response => {
      context.commit("SET_USER_EVENT_LIST", response);
      context.state.loading = false;
    });
  },
  async createEventFile(context, data) {
    context.state.fileFetching = true;
    var api = await services.api;
    return api.createEventFile(data).then(response => {
      context.state.fileFetching = false;
      return response;
    });
  },
  async emailEventFile(context, data) {
    context.state.fileFetching = true;
    var api = await services.api;
    return api.emailEventFile(data).then(response => {
      context.state.fileFetching = false;
    });
  },
  async SAVE(context, data) {
    var api = await services.api;
    return api
      .save(data)
      .then(function(value) {
        return data;
      })
      .catch(
        /* istanbul ignore next */ function(err) {
          errorHelper.showError(err);
        }
      );
  },
  async LOAD(context) {
    var api = await services.api;
    return api
      .load(context)
      .then(function(value) {
        state.data = value;
        state.parsedData = actions.getData(context, value);
        return state.parsedData;
      })
      .catch(
        /* istanbul ignore next */ function(err) {
          errorHelper.showError(err);
        }
      );
  },
  getData(context, data) {
    var p = _.find(data, function(i) {
      return i.Type === "OFF_HOURS_PHONE_NUMBER";
    });

    var d = _.find(data, function(i) {
      return i.Type === "CALL_CENTER_HOURS";
    });

    return {
      phoneNumber: p.Value,
      dayData: JSON.parse(d.Value)
    };
  }
};

const getters = {
  userEvents: storeState => storeState.userEvents,
  fileFetching: storeState => storeState.fileFetching
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
